// extracted by mini-css-extract-plugin
export default {"categories":"Categories-module__categories--rnscK","low-priority":"Categories-module__low-priority--EfIli"};